import React from 'react'
import styled from 'styled-components'

interface Props {
  className?: string
}

const SectionBottom: React.FC<Props> = ({ className, children }) => {
  return <StyledSectionBottom className={className}>{children}</StyledSectionBottom>
}

const StyledSectionBottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 20px 36px 20px;
  width: 100%;

  &:empty {
    display: none;
  }
`
export default SectionBottom
